export default (name: string, id: number, redirectTo: string) => {
  const message = `Etes-vous sur de vouloir supprimer "${name}" . Toutes les informations seront perdues…`;
  if (confirm(message)) {
    document.location = `${redirectTo}/delete.php?id=${id}`;
  }
};
